import { FormlyFieldConfig } from '@ngx-formly/core';

export function nricValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return `Please enter a valid NRIC number`;
}

export function uniqueNricInArrayValidatorMessage(error: string[], field: FormlyFieldConfig): string {
  return `The NRIC(s) is already taken: ${error.join(', ')}`;
}
